
class Search {
    constructor() {
        this.searchBar = $('.dropdown-searchbox');
        this.closeSearchButton = this.searchBar.find('.search-close');
        this.openSearchButton = $('.header-search');
        this.searchInput = this.searchBar.find('.search-input');

        this.closeSearchButton.on('click', event => this.toggleSearch(event));
        this.openSearchButton.on('click', event => this.toggleSearch(event));

    }

    toggleSearch(e) {
        e.preventDefault();

        this.openSearchButton.toggleClass('icon-search');
        this.openSearchButton.toggleClass('icon-close');

        this.searchBar.toggleClass('d-block');
        this.searchInput.focus();
    }

}

export default Search;